"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _AuPlate = _interopRequireDefault(require("./AuPlate"));
var _AuButton = _interopRequireWildcard(require("./AuButton"));
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
var _constants = require("../../constants");
var _context;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "container": "generic_error-module__container___BXo7x",
  "text_block": "generic_error-module__text_block___MDMOH",
  "help_box": "generic_error-module__help_box___LR8t2",
  "msg": "generic_error-module__msg___pgiMz",
  "button": "generic_error-module__button____9jc0",
  "title": "generic_error-module__title___UyT_O",
  "suggestion": "generic_error-module__suggestion___LithN",
  "help_buttons": "generic_error-module__help_buttons___Q0UfL"
};
class GenericError extends _react.default.Component {
  static propTypes = {
    history: T.shape({
      push: T.func.isRequired,
      goBack: T.func.isRequired,
      location: T.shape({
        hash: T.string.isRequired
      }).isRequired
    }).isRequired,
    code: T.oneOfType([T.number, T.string]),
    className: T.string,
    titleDisplay: T.string,
    titleDisplayId: T.string,
    messageDisplay: T.string,
    messageDisplayId: T.string,
    solutionText: T.string,
    solutionTextId: T.string
  };
  static defaultProps = {
    code: 404
  };
  onBackBtnClick = (0, _bind.default)(_context = this.onBackBtnClick).call(_context, this);
  onBackBtnClick() {
    const {
      history: browserHistory
    } = this.props;
    // if location hash exists - we were navigated here from the KC.
    return browserHistory.location.hash ? browserHistory.push('/') : browserHistory.goBack();
  }
  openInNewTab = url => {
    window.open(url, "_blank", "noreferrer");
  };
  render() {
    const {
      code,
      className,
      titleDisplay,
      messageDisplay,
      messageDisplayId
    } = this.props;
    let help_buttons = [];
    let urls = [];

    // Currently, the only plate that would be shown is one with a 404 code. Keeping this conditional in the event that this changes in the future
    switch (code) {
      case 404:
        help_buttons = ['au.errors.iamService', 'au.errors.tmcInstances', 'au.errors.support'];
        urls = [_constants.IAM_SERVICE_LINK, _constants.TMC_INSTANCES_LINK, _constants.SUPPORT_LINK];
        break;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.container, className)
    }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      className: styles.title,
      displayId: code == 404 ? 'au.error.title' : 'au.error.apology'
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.text_block
    }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      className: styles.msg,
      displayId: messageDisplayId,
      displayString: messageDisplay,
      tag: "div"
    }), /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      className: styles.msg,
      displayId: `au.errors.${code}.help`,
      values: {
        emailLink: /*#__PURE__*/_react.default.createElement("a", {
          href: "mailto:tmchelp@ford.com",
          style: {
            color: '#18A'
          }
        }, "tmchelp@ford.com"),
        iamLink: /*#__PURE__*/_react.default.createElement("a", {
          href: "https://developer.autonomic.ai/getting-started/getting-started-on-the-tmc-platform/about-the-tmc/permissions-policies-and-roles/roles--permissions/",
          style: {
            color: '#18A'
          },
          target: "_blank"
        }, "IAM Service")
      },
      displayString: 'Please try again later',
      tag: "div"
    })), /*#__PURE__*/_react.default.createElement(_AuPlate.default, {
      contentDisplay: code,
      titleDisplay: titleDisplay,
      titleDisplayId: `au.errors.${code}.title`
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.help_box
    }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      className: styles.suggestion,
      displayId: 'au.errors.suggestion',
      tag: "div"
    }), /*#__PURE__*/_react.default.createElement("div", null, (0, _map.default)(help_buttons).call(help_buttons, (button, ind) => {
      return /*#__PURE__*/_react.default.createElement(_AuButton.default, {
        key: button,
        className: styles.help_buttons,
        onClick: () => this.openInNewTab(urls[ind]),
        type: _AuButton.BUTTON_TYPE_PLAIN,
        displayId: button
      });
    }))));
  }
}
exports.default = GenericError;